var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMainHeader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 620,
    viewBox: "0 0 1440 620",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 184,
    cy: 141,
    r: 263,
    stroke: "#6587FA",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 799,
    cy: 473,
    r: 13,
    stroke: "#6587FA",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 333,
    cy: 501,
    r: 13,
    stroke: "#6587FA",
    strokeWidth: 2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 1355,
    cy: 73,
    r: 199,
    stroke: "#6587FA",
    strokeWidth: 2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.05,
    cx: 1285,
    cy: 211,
    r: 125,
    fill: "#6587FA"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 291,
    cy: 535,
    r: 29,
    stroke: "#6587FA",
    strokeWidth: 2
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 241,
    cy: 570,
    r: 50,
    fill: "#6587FA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainHeader);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQ0MCIgaGVpZ2h0PSI2MjAiIHZpZXdCb3g9IjAgMCAxNDQwIDYyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBvcGFjaXR5PSIwLjEiIGN4PSIxODQiIGN5PSIxNDEiIHI9IjI2MyIgc3Ryb2tlPSIjNjU4N0ZBIiBzdHJva2Utd2lkdGg9IjIiLz4KPGNpcmNsZSBvcGFjaXR5PSIwLjEiIGN4PSI3OTkiIGN5PSI0NzMiIHI9IjEzIiBzdHJva2U9IiM2NTg3RkEiIHN0cm9rZS13aWR0aD0iMiIvPgo8Y2lyY2xlIG9wYWNpdHk9IjAuMSIgY3g9IjMzMyIgY3k9IjUwMSIgcj0iMTMiIHN0cm9rZT0iIzY1ODdGQSIgc3Ryb2tlLXdpZHRoPSIyIi8+CjxjaXJjbGUgb3BhY2l0eT0iMC4xIiBjeD0iMTM1NSIgY3k9IjczIiByPSIxOTkiIHN0cm9rZT0iIzY1ODdGQSIgc3Ryb2tlLXdpZHRoPSIyIi8+CjxjaXJjbGUgb3BhY2l0eT0iMC4wNSIgY3g9IjEyODUiIGN5PSIyMTEiIHI9IjEyNSIgZmlsbD0iIzY1ODdGQSIvPgo8Y2lyY2xlIG9wYWNpdHk9IjAuMiIgY3g9IjI5MSIgY3k9IjUzNSIgcj0iMjkiIHN0cm9rZT0iIzY1ODdGQSIgc3Ryb2tlLXdpZHRoPSIyIi8+CjxjaXJjbGUgb3BhY2l0eT0iMC4xIiBjeD0iMjQxIiBjeT0iNTcwIiByPSI1MCIgZmlsbD0iIzY1ODdGQSIvPgo8L3N2Zz4K";
export { ForwardRef as ReactComponent };